import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#ffffff1a',
} as const

export const resources = {
  loginBg: '',
  logo: '',
  novel: '',
  facebookIcon: '/images/ficmoon/login/icon-facebook-logo.png',
  googleIcon: '/images/ficmoon/login/icon-google-logo.png',
  appleIcon: '/images/ficmoon/login/icon-apple-logo.png',
  emailIcon: '/images/ficmoon/login/icon-email.png',
  emailCodeIcon: '/images/ficmoon/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: loginCommonConfig.texts,
}
